'use strict';

export function initMobileNav() {
    const menuBtn = document.getElementById('menuBtn');
    const menuClose = document.getElementById('menuClose');
    const mobileMenu = document.getElementById('mobileMenu');
    menuBtn?.addEventListener('click', () => mobileMenu.classList.add('open'));
    menuClose?.addEventListener('click', () => mobileMenu.classList.remove('open'));
    document.querySelectorAll('.menu-link').forEach(l => l.addEventListener('click', () => mobileMenu.classList.remove('open')));

    function updateStickyOffset() {
        const offset = parseInt(
            getComputedStyle(document.body)
                .getPropertyValue('--drupal-displace-offset-top'),
            10
        ) || 0;

        mobileMenu.style.top = `${offset}px`;
    }

    window.addEventListener('DOMContentLoaded', updateStickyOffset)
    window.addEventListener('resize', updateStickyOffset);
}



